<template>
  <div class="page">
    <div class="count-item">
      <strong>当前手机号</strong>
      <div @click="changePhone">
        <div>{{ phone }}</div>
        <img src="../../assets/info/next.png" alt="" />
      </div>
    </div>

    <div class="count-version">{{ version }}</div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";

export default {
  name: "Count",

  data() {
    return {
      phone: "",
      version: "",
    };
  },

  created() {
    document.title = "账号设置";

    let data = JSON.parse(decodeURI(this.$route.query.data + ""));
    this.phone = data.phone;
    this.version = data.version;
  },

  methods: {
    changePhone() {
      wx.miniProgram.getEnv(function () {
        wx.miniProgram.navigateTo({
          url: "/pages/setting/bind",
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
// @import "../../css/page";

.page {
  top: 0;
  left: 0;
  background: #EEEEEE;
  position: fixed;
  width: 102%; //隐藏滚动条
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}

.count-item {
  border-radius: 10px;
  height: 44px;
  color: #333333;
  box-sizing: border-box;
  width: 90%;
  background: white;
  display: flex;
  margin: 10px auto;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  div {
    color: #999999;
    align-items: center;
    display: flex;
  }
  img {
    height: 22px;
    width: 22px;
  }
}

.count-version {
  text-align: center;
  width: 100%;
  bottom: 14px;
  position: absolute;
  color: #999999;
}
</style>
